import React, { Component } from "react";
import queryString from "query-string";
import { Result, Descriptions } from "antd";
import { PostData } from "../api/service";
import OnlineMethod from "../Components/Payment/OnlineMethod";

class IdCardPaymentPage extends Component {
  state = {
    id_card_request_id: "",
    email: "",
    isLoaded: false,
    status: null,
    data: null,
    errorMessage: ""
  };

  componentDidMount() {
    const search = this.props.history.location.search;
    const searchData = queryString.parse(search);

    if (searchData && searchData.id_card_request_id && searchData.email) {
      this.setState(
        {
          id_card_request_id: searchData.id_card_request_id,
          email: searchData.email
        },
        () => this.loadRequest()
      );
    } else {
      this.setState({
        isLoaded: true,
        status: false,
        errorMessage: "Missing request id or email in the URL."
      });
    }
  }

  loadRequest = () => {
    PostData("/get-id-card-request-for-payment", {
      id_card_request_id: this.state.id_card_request_id,
      email: this.state.email
    })
      .then((resp) => {
        if (resp && resp.status === true && resp.data) {
          this.setState({
            isLoaded: true,
            status: true,
            data: resp.data
          });
        } else {
          this.setState({
            isLoaded: true,
            status: false,
            errorMessage:
              "Request not found. Please verify the link from your email."
          });
        }
      })
      .catch(() => {
        this.setState({
          isLoaded: true,
          status: false,
          errorMessage: "Something went wrong. Please try again later."
        });
      });
  };

  renderBody() {
    const { data } = this.state;
    const fee = parseFloat(data.registration_fee) || 0;
    const paid = parseInt(data.payment_status, 10) === 1;

    if (paid) {
      return (
        <Result
          status="success"
          title="Payment already completed"
          subTitle={`Your ${data.type_name} application (Ref #${data.id}) has been paid. The college office will print your card.`}
        >
          <Descriptions column={1} bordered={true} size="small">
            <Descriptions.Item label="Applicant">
              <strong>{data.name}</strong>
            </Descriptions.Item>
            <Descriptions.Item label="Roll No">{data.roll_no}</Descriptions.Item>
            <Descriptions.Item label="Applied For">{data.type_name}</Descriptions.Item>
            <Descriptions.Item label="Amount Paid">
              &#8377; {data.amount_paid}
            </Descriptions.Item>
            <Descriptions.Item label="Paid On">
              {data.amount_paid_on}
            </Descriptions.Item>
          </Descriptions>
        </Result>
      );
    }

    if (fee <= 0) {
      return (
        <Result
          status="warning"
          title="No fee configured"
          subTitle="This ID card type has no fee set. Please contact the college office."
        />
      );
    }

    return (
      <div>
        <Descriptions column={1} bordered={true} size="small">
          <Descriptions.Item label="Applicant">
            <strong>{data.name}</strong>
          </Descriptions.Item>
          <Descriptions.Item label="Roll No">{data.roll_no}</Descriptions.Item>
          <Descriptions.Item label="Applied For">{data.type_name}</Descriptions.Item>
          <Descriptions.Item label="Amount Payable">
            &#8377; {fee}
          </Descriptions.Item>
          <Descriptions.Item label="Email">{data.email}</Descriptions.Item>
          <Descriptions.Item label="Phone">{data.phone}</Descriptions.Item>
        </Descriptions>
        <br />
        <OnlineMethod
          endpoint="/getpaymentstringidcardrequest"
          payload={{
            id_card_request_id: this.state.id_card_request_id,
            email: this.state.email
          }}
          amount={fee}
        />
      </div>
    );
  }

  render() {
    return (
      <div className="jumbotron">
        <div className="container">
          <div className="reg-form">
            <div className="top-bar"></div>
            <div className="form-contents">
              <h3
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center"
                }}
              >
                <div style={{ marginLeft: 0, fontWeight: 700 }}>
                  ID Card Fee Payment
                </div>
              </h3>
              <hr />

              {!this.state.isLoaded && <div>Loading . . . Please wait</div>}

              {this.state.isLoaded && this.state.status === true && this.renderBody()}

              {this.state.isLoaded && this.state.status === false && (
                <Result
                  status="error"
                  title="Unable to load payment"
                  subTitle={this.state.errorMessage}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default IdCardPaymentPage;
